import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import { RootState } from '@Redux/detail/store';
import { setGroupDetailSync } from '@Redux/detail/Group/actions';
// import Tags from './subComponents/Tags';
import Tags from '@components/Common/Tags';
import Spinner from '@components/Common/Spinner';
import Register from './subComponents/Register';
import Info from './subComponents/Info';
import styles from './style.module.scss';

const GroupDetail = () => {
    const { GroupInfo, isLoading } = useSelector((store: RootState) => store.groupReducer);
    const dispatch = useDispatch();

    useEffect(() => {
        const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;

        dispatch(setGroupDetailSync({ ...JSON.parse(travelinfo!), isLoading: false }));
    }, [dispatch]);

    return !!GroupInfo && !isLoading ? (
        <div className={cN(styles['group_detail'], 'group_detail')}>
            {!!GroupInfo.TourBuName && (
                <div className={styles.bu}>聯營商品:{GroupInfo.TourBuName}</div>
            )}
            <div className={styles.title}>{GroupInfo.TourName}</div>
            <Tags
                IsVip={GroupInfo.IsVip}
                TripTypeList={GroupInfo.TripTypeList}
                TagList={GroupInfo.TagList}
                isOnlyMobileHide={true}
                isToggleLightBox={true}
            />
            <Info />
            <Register />
        </div>
    ) : (
        <Spinner />
    );
};

export default React.memo(GroupDetail);
